let company = {};

company = require('../data/company')

module.exports = company;